<div class="error-page">
  <div>
    <h2 class="title">{{title}}</h2>
    <div class="description" >{{description}}
    </div>
 </div>
</div>
